import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IUserMast } from "../../models/UserMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { EmptyUser } from "./EmptyUser";

const schema = yup.object({
    user_Name: yup.string().required("UserName is required*").min(3),
    login_Name: yup.string().required("LoginName is required*").min(3),
    user_EmailID: yup.string().required("UserEmailID is required*"),
    user_Status: yup.boolean().required("UserStatus is required*"),
    temp_Inactive: yup.boolean().required("UserStatus is required*"),
    login_Password: yup.string().required("loginPassword is required*"),
});

interface Iprops {
    singleData: IUserMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IUserMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IUserMast) => {
        setLoading(true);
        const method = props.singleData.login_ID ? "PUT" : "POST";
        const message = props.singleData.login_ID ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("ExternalUser_Mast", method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyUser);
    }

    function onSubmit(data: IUserMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit User" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Name" control={control} name="user_Name" error={errors.user_Name?.message} />
                <JVInput required label="Email" control={control} name="user_EmailID" error={errors.user_EmailID?.message} />
                <JVInput required label="LoginID" control={control} name="login_Name" error={errors.login_Name?.message} />
                <JVInput required label="Password" control={control} name="login_Password" error={errors.login_Password?.message} />
                <JVCheckbox column={4} required label="Status" control={control} name="user_Status" />
                <JVCheckbox column={4} required label="Temp Inactive" control={control} name="temp_Inactive" />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" loading={loading} label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}